"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { jsx, jsxs } from "react/jsx-runtime";
import React from "react";
import $ from "jquery";
import _ from "underscore";
import {
  toggleAnnotatingStatus,
  adjustTone,
  editTextAnnotationText,
  doneEditingTextAnnotation,
  deleteAnnotation
} from "../redux/actions";
import ApiService from "../../services/api_service";
import Api from "../../api/api";
import Account from "../../api/account";
import DataStoreService from "../data_store_service";
import { connect } from "react-redux";
import documentEditor from "../document_editor";
import fetch from "../../util/fetch";
import PageToolbar from "./page_toolbar";
import AnnotateToolbar from "./annotate_toolbar";
import reactUtils from "../../react_utils";
import WaitingSpinner from "../../components/waiting_spinner";
import ZoomableImage from "./zoomable_image";
import Zoomer from "../../helpers/zoomer";
import allowedAsPod from "../../helpers/allowed_as_pod";
import { isOnIndexStep, flowStep } from "../flow_steps";
import allowedAsCarrierDocument from "../../helpers/allowed_as_carrier_document";
import getDocumentAssignmentComponent from "../document_assignment/document_assignment_loader";
import hotkeys from "../../util/hotkeys";
import {
  DocumentBatchGroupCreator,
  GroupedDocumentBrowserModel
} from "../grouped_document_browser_model";
import { Flash } from "../../components/flash";
import { readOnly } from "../../helpers/factor_invoice";
import Auth from "../../util/auth";
import { isPodForLoad } from "../helpers/document_load_relationship_helpers";
import { podDispositionLabel } from "./pod_disposition_label";
import {
  shouldShowPodUncheckModal,
  shouldShowPodCheckModal,
  renderPodUncheckReasonModal,
  renderPodCheckReasonModal
} from "../indexer/pod_modal_logic";
import { setPOD } from "../../helpers/documents";
import loadDocumentRelationshipService from "../../services/load_document_relationship_service";
import { push } from "../app_history";
const emptyGroupedDocumentBrowserModel = new GroupedDocumentBrowserModel(
  DocumentBatchGroupCreator([], () => false)
);
const pageKeyForAttachmentIsProcessingByPage = ({ document_id, number }) => JSON.stringify({ document_id, number });
const bem = reactUtils.makeBem("page-toolbar");
const annotationStampUrl = (model) => model.selectedDocument.annotation_stamp_url;
const carrierDocumentAccount = () => Api.Account.current().settings.carrier_documents_account;
const showDespeckle = () => Api.Account.current().settings.show_despeckle_tone_slider;
const showMarkIllegibleButton = (props) => {
  if (Api.Account.current().factor_account) {
    return !props.currentInvoice || !readOnly(props.currentInvoice);
  } else {
    return !props.isConfirmAndSubmit || props.currentInvoice && !props.currentInvoice.approved_at;
  }
};
const canToggleHidden = (props) => {
  var _a;
  return !!props.toggleHiddenData && !((_a = props.currentInvoice) == null ? void 0 : _a.approved_at);
};
const showCarrierDocumentsOption = (document) => carrierDocumentAccount() && allowedAsCarrierDocument(document);
const isGroupedDocumentBrowserModel = (x) => {
  return x != null && typeof x.allDocuments === "function";
};
const viewEmail = (props) => {
  return function() {
    const group = props.model.selectedGroup;
    if (!group) {
      return;
    }
    if (group.url && !group.areLoadDocuments) {
      const invoiceId = group.documents[0].carrier_invoice_id || group.documents[0].factor_invoice_id;
      const onDone = props.location.query.onDone || "/dashboard";
      push(group.url, { invoiceId, onDone });
    } else if (group.url && group.areLoadDocuments) {
      const onDone = props.location.query.onDone || "/dashboard";
      push(group.url, { onDone });
    }
  };
};
const documentBrowserSubNav = (props) => {
  if (!props.annotating) {
    return /* @__PURE__ */ jsx("div", { className: "document-browser__sub-nav", children: /* @__PURE__ */ jsxs("div", { className: "document-browser__sub-nav_description", children: [
      podStatus(props),
      clientOrDebtorOnBol(props),
      carrierDocumentStatus(props)
    ] }) });
  }
};
export const podStatus = (props) => {
  var _a;
  const document = props.model.selectedDocument;
  if (props.allowsEditingPodStatus && !props.annotating && document) {
    if (allowedAsPod(document)) {
      if (isOnIndexStep(props) && props.selectedLoad && props.selectedLoad.requires_auditor_manual_marking_of_POD) {
        return /* @__PURE__ */ jsx("div", { className: "document-browser__pod-status", children: /* @__PURE__ */ jsx("em", { children: "Cannot mark PODs during indexing for this customer" }) });
      } else if (!isOnIndexStep(props) && Account.podDefinitionModuleEnabled() && !((_a = props.currentInvoice) == null ? void 0 : _a.pod_requirement_skipped)) {
        return /* @__PURE__ */ jsx("div", { className: "document-browser__pod-status", children: /* @__PURE__ */ jsx("em", { children: "Expand POD exception on the left to view and edit POD status." }) });
      } else {
        const load = props.load || props.selectedLoad;
        const isPod = isPodForLoad(
          document,
          load,
          props.documentLoadRelationships
        );
        return /* @__PURE__ */ jsxs(
          "div",
          {
            className: "document-browser__pod-status",
            title: "Mark POD - 0 (Numpad) or Alt+D",
            children: [
              /* @__PURE__ */ jsx(
                "input",
                {
                  className: "document-browser__pod-status-checkbox",
                  checked: isPod,
                  onChange: () => props.handlePodToggle ? props.handlePodToggle(document, "includesPOD") : props.toggleDocumentData(document, "includesPOD"),
                  type: "checkbox",
                  id: "use-as-pod"
                }
              ),
              /* @__PURE__ */ jsxs("div", { children: [
                /* @__PURE__ */ jsx(
                  "label",
                  {
                    className: "document-browser__pod-status-label",
                    htmlFor: "use-as-pod",
                    children: "Signed: Use as Proof of Delivery"
                  }
                ),
                podDispositionLabel(
                  document,
                  load,
                  props.documentLoadRelationships
                )
              ] })
            ]
          }
        );
      }
    } else if (!showCarrierDocumentsOption(document)) {
      return /* @__PURE__ */ jsx("div", { className: "document-browser__pod-status", children: /* @__PURE__ */ jsx("em", { children: "This document type may not be used as a proof of delivery." }) });
    }
  }
};
export const clientOrDebtorOnBol = (props) => {
  const document = props.model.selectedDocument;
  const factorInvoice = props.currentInvoice;
  if (props.allowsEditingPodStatus && !props.annotating && factorInvoice && factorInvoice.show_client_debtor_check && document && document.type == "billOfLading") {
    return /* @__PURE__ */ jsxs("div", { className: "document-browser__client-or-debtor-status", children: [
      /* @__PURE__ */ jsx(
        "input",
        {
          className: "document-browser__pod-status-checkbox",
          onChange: () => props.toggleClientDebtorCheck(factorInvoice),
          type: "checkbox",
          checked: factorInvoice.client_or_debtor_on_bol,
          disabled: props.savingInvoice || readOnly(factorInvoice)
        }
      ),
      /* @__PURE__ */ jsx(
        "label",
        {
          className: "document-browser__pod-status-label",
          htmlFor: "use-as-pod",
          children: "Client or Debtor on BOL"
        }
      )
    ] });
  }
};
export const carrierDocumentStatus = (props) => {
  const document = props.model.selectedDocument;
  if (showCarrierDocumentsOption(document) && props.allowsEditingPodStatus) {
    if (assignedCarrierId(props)) {
      return /* @__PURE__ */ jsxs("div", { className: "document-browser__pod-status", children: [
        /* @__PURE__ */ jsx(
          "input",
          {
            className: "document-browser__pod-status-checkbox",
            checked: !!document.carrier_document_tms_carrier_id,
            onChange: () => {
              props.toggleCarrierDocument(document, assignedCarrierId(props));
            },
            type: "checkbox",
            id: "use-as-carrier_document"
          }
        ),
        /* @__PURE__ */ jsxs(
          "label",
          {
            className: "document-browser__pod-status-label",
            htmlFor: "use_as_carrier_document",
            children: [
              "Save as ",
              Account.carrierTerm(),
              " Document",
              /* @__PURE__ */ jsx("span", { children: /* @__PURE__ */ jsxs(
                "a",
                {
                  href: "/app/settings/carriers/" + assignedCarrierId(props) + "/documents",
                  target: "_blank",
                  children: [
                    " ",
                    "View current documents for ",
                    Account.carrierTermLower(),
                    "."
                  ]
                }
              ) })
            ]
          }
        )
      ] });
    } else {
      return /* @__PURE__ */ jsx("div", { className: "document-browser__pod-status", children: /* @__PURE__ */ jsxs("em", { children: [
        "You must assign a ",
        Account.carrierTermLower(),
        " if you wish to save this as a ",
        Account.carrierTermLower(),
        " document."
      ] }) });
    }
  }
};
const assignedCarrierId = (props) => {
  if (props.carrier) {
    return props.carrier.id;
  }
  const batch = props.documentBatch;
  return batch && (batch.carrierId || batch.email_message && batch.email_message.carrier_id);
};
const attachmentIsProcessingByPageFor = (pages) => pages.reduce((attachmentIsProcessingByPage_, page) => {
  const pageKey = pageKeyForAttachmentIsProcessingByPage(page);
  return __spreadProps(__spreadValues({}, attachmentIsProcessingByPage_), {
    [pageKey]: !!page.attachmentIsProcessing
  });
}, {});
export class DocumentBrowserMainImage extends React.Component {
  // LIFECYCLE
  constructor(props) {
    super(props);
    __publicField(this, "zoomer");
    __publicField(this, "previouslySeenPage");
    __publicField(this, "mounted", false);
    __publicField(this, "modelForAnnotations", () => {
      if (isGroupedDocumentBrowserModel(this.props.model))
        return this.props.model;
      else return emptyGroupedDocumentBrowserModel;
    });
    __publicField(this, "allDocumentPages", () => {
      const allDocuments_ = this.modelForAnnotations().allDocuments();
      if (allDocuments_ != null)
        return allDocuments_.reduce(
          (allDocumentPages, doc) => [...allDocumentPages, ...doc.pages],
          []
        );
      else return [];
    });
    __publicField(this, "handlePageReplaced", (_args, page) => {
      if (page == null) {
        return;
      }
      const currentPage_ = this.currentPage();
      const key = pageKeyForAttachmentIsProcessingByPage(page);
      const currentPageFinishedProcessing = currentPage_ && currentPage_.document_id === page.document_id && currentPage_.number === page.number && this.attachmentIsProcessing() && !page.attachmentIsProcessing;
      const attachmentIsProcessingByPage = __spreadProps(__spreadValues({}, this.state.attachmentIsProcessingByPage), {
        [key]: page.attachmentIsProcessing
      });
      this.setState({
        attachmentIsProcessingByPage
      });
      if (currentPageFinishedProcessing)
        Flash.success("Saved annotations successfully!");
    });
    // STATE
    __publicField(this, "adjustTone", (adjustment, value) => {
      this.props.dispatch(adjustTone(adjustment, value));
    });
    __publicField(this, "fetchLines", (page) => {
      if (page && page.id && _.isUndefined(page.lines)) {
        ApiService.addErrorHandler(
          fetch(`/api/document_pages/${page.id}/lines`).then((response) => {
            page.lines = response.lines;
            if (this.mounted) {
              this.forceUpdate();
            }
            return null;
          }),
          null,
          {
            caller: "DocumentBrowserMainImage.fetchLines"
          }
        );
      }
    });
    __publicField(this, "resetToolState", () => {
      this.zoomer = new Zoomer();
      this.setState({ zoomLevel: this.zoomer.zoomLevel, justSaved: false });
    });
    __publicField(this, "zoomIn", () => {
      this.zoomer.zoomIn();
      this.setState({ zoomLevel: this.zoomer.zoomLevel });
    });
    __publicField(this, "zoomOut", () => {
      this.zoomer.zoomOut();
      this.setState({ zoomLevel: this.zoomer.zoomLevel });
    });
    __publicField(this, "rotateLeft", (_event) => {
      if (this.state.updating) {
        return false;
      }
      this._withUpdate(documentEditor.rotateLeft(this.currentPage()));
    });
    __publicField(this, "rotateRight", (_event) => {
      if (this.state.updating) {
        return false;
      }
      this._withUpdate(documentEditor.rotateRight(this.currentPage()));
    });
    __publicField(this, "attachmentIsProcessing", () => {
      if (this.currentPage != null) {
        const pageKey = pageKeyForAttachmentIsProcessingByPage(
          this.currentPage()
        );
        return this.state.attachmentIsProcessingByPage[pageKey];
      }
      return false;
    });
    __publicField(this, "currentPage", () => {
      return this.props.model.selectedPage;
    });
    __publicField(this, "split", () => {
      const model = this.props.model;
      this._withUpdate(
        documentEditor.split(model.selectedDocument.id, model.selectedPage.id)
      );
    });
    __publicField(this, "merge", () => {
      const model = this.props.model;
      this._withUpdate(
        documentEditor.merge(
          model.selectedDocument.id,
          // merge is only reachable through PageToolbar when canMerge is true
          model.previousDocument().id
        )
      );
    });
    __publicField(this, "duplicate", () => {
      const model = this.props.model;
      this._withUpdate(documentEditor.duplicate(model.selectedDocument.id));
    });
    __publicField(this, "_withUpdate", (promise) => {
      this.setState({ updating: true });
      this.currentPage().lines = void 0;
      promise.then(() => {
        this.setState({ updating: false });
      }).catch(() => {
        this.setState({ updating: false });
        return {};
      });
    });
    __publicField(this, "toggleAnnotation", () => {
      this.props.dispatch(toggleAnnotatingStatus());
    });
    __publicField(this, "toggleHidden", () => {
      this.props.toggleHiddenData(
        this.props.model.selectedDocument,
        this.props.page
      );
    });
    // POD Modal Helper Functions
    __publicField(this, "openPodUncheckReasonModal", (document, load) => {
      this.setState({
        showPodUncheckReasonModal: true,
        podUncheckReasonDocument: document,
        podUncheckReasonLoad: load
      });
      if (this.props.forceUpdateAndRefreshPopout) {
        this.props.forceUpdateAndRefreshPopout();
      }
    });
    __publicField(this, "openPodCheckReasonModal", (document, load) => {
      this.setState({
        showPodCheckReasonModal: true,
        podCheckReasonDocument: document,
        podCheckReasonLoad: load
      });
      if (this.props.forceUpdateAndRefreshPopout) {
        this.props.forceUpdateAndRefreshPopout();
      }
    });
    // POD Toggle Handler
    __publicField(this, "handlePodToggle", (document, field) => {
      if (field === "includesPOD") {
        const load = this.props.load || this.props.selectedLoad;
        if (!load) {
          this.props.toggleDocumentData(document, field);
          return;
        }
        const currentIsPod = isPodForLoad(
          document,
          load,
          this.props.documentLoadRelationships
        );
        const newIsPod = !currentIsPod;
        if (shouldShowPodUncheckModal(currentIsPod, newIsPod)) {
          this.openPodUncheckReasonModal(document, load);
          return;
        }
        if (shouldShowPodCheckModal(currentIsPod, newIsPod)) {
          this.openPodCheckReasonModal(document, load);
          return;
        }
      }
      this.props.toggleDocumentData(document, field);
    });
    __publicField(this, "markIllegible", () => {
      this.props.toggleMarkIllegibleData(
        this.props.model.selectedDocument,
        this.props.page
      );
    });
    __publicField(this, "toneSliders", () => {
      if (this.props.annotating && this.props.showToneSliders) {
        return /* @__PURE__ */ jsxs(
          "div",
          {
            className: "f-dropdown content medium open f-open-dropdown docviewer-tone-sliders",
            style: {
              position: "absolute",
              left: 0,
              top: "8em",
              zIndex: 9999
            },
            children: [
              /* @__PURE__ */ jsxs("p", { children: [
                /* @__PURE__ */ jsx("label", { htmlFor: "sharpen-slider", children: "Sharpen" }),
                /* @__PURE__ */ jsx(
                  "input",
                  {
                    type: "range",
                    min: "0",
                    max: "100",
                    value: this.props.toneAdjustments.sharpen,
                    id: "sharpen-slider",
                    step: "1",
                    onChange: (e) => this.adjustTone("sharpen", e.target.value)
                  }
                ),
                /* @__PURE__ */ jsx("span", { children: this.props.toneAdjustments.sharpen })
              ] }),
              /* @__PURE__ */ jsxs("p", { children: [
                /* @__PURE__ */ jsx("label", { htmlFor: "contrast-slider", children: "Contrast" }),
                /* @__PURE__ */ jsx(
                  "input",
                  {
                    type: "range",
                    min: "-100",
                    max: "100",
                    value: this.props.toneAdjustments.contrast,
                    id: "contrast-slider",
                    step: "1",
                    onChange: (e) => this.adjustTone(
                      "contrast",
                      e.target.value
                    )
                  }
                ),
                /* @__PURE__ */ jsx("span", { children: this.props.toneAdjustments.contrast })
              ] }),
              /* @__PURE__ */ jsxs("p", { children: [
                /* @__PURE__ */ jsx("label", { htmlFor: "brightness-slider", children: "Brightness" }),
                /* @__PURE__ */ jsx(
                  "input",
                  {
                    type: "range",
                    min: "-100",
                    max: "100",
                    value: this.props.toneAdjustments.brightness,
                    id: "brightness-slider",
                    step: "1",
                    onChange: (e) => this.adjustTone(
                      "brightness",
                      e.target.value
                    )
                  }
                ),
                /* @__PURE__ */ jsx("span", { children: this.props.toneAdjustments.brightness })
              ] }),
              this.maybeShowDespeckle()
            ]
          }
        );
      }
    });
    __publicField(this, "maybeShowDespeckle", () => {
      if (showDespeckle()) {
        return /* @__PURE__ */ jsxs("p", { children: [
          /* @__PURE__ */ jsx("label", { htmlFor: "despeckle-slider", children: "Despeckle" }),
          /* @__PURE__ */ jsx(
            "input",
            {
              type: "range",
              min: "0",
              max: "20",
              value: this.props.toneAdjustments.despeckle,
              id: "despeckle-slider",
              step: "1",
              onChange: (e) => this.adjustTone("despeckle", e.target.value)
            }
          ),
          /* @__PURE__ */ jsx("span", { children: this.props.toneAdjustments.despeckle })
        ] });
      }
    });
    __publicField(this, "noDocumentsView", () => {
      return /* @__PURE__ */ jsx("div", { className: "document-browser__main-image-container", children: /* @__PURE__ */ jsx("div", { className: "document-browser__main-image-container-no-images", children: /* @__PURE__ */ jsx("div", { className: "alert-box--highlight", children: "No Documents Are Available" }) }) });
    });
    __publicField(this, "possiblePodUncheckReasonModal", () => {
      if (!this.state.showPodUncheckReasonModal) return null;
      const onClose = () => {
        const document = this.state.podUncheckReasonDocument;
        setPOD(document, true);
        this.setState({
          showPodUncheckReasonModal: false,
          podUncheckReasonDocument: null,
          podUncheckReasonLoad: null
        });
        if (this.props.forceUpdateAndRefreshPopout) {
          this.props.forceUpdateAndRefreshPopout();
        }
      };
      const onSubmit = (reasonCodes, otherReasonText) => {
        const document = this.state.podUncheckReasonDocument;
        const load = this.state.podUncheckReasonLoad;
        if (this.props.removeDeliveryDocumentSelectionsForDocument) {
          this.props.removeDeliveryDocumentSelectionsForDocument(document);
        }
        setPOD(document, false);
        loadDocumentRelationshipService.forcePodDispositionForDocument(
          document.id,
          false
        );
        const isConfirmSubmit = this.props.isConfirmAndSubmit;
        const extras = {
          load_state_id: load.id,
          page: isConfirmSubmit ? "confirm_and_submit" : "assign_to_load",
          pod_toggled: true,
          pod_reason_codes: reasonCodes,
          pod_reason: otherReasonText
        };
        this.setState({
          showPodUncheckReasonModal: false,
          podUncheckReasonDocument: null,
          podUncheckReasonLoad: null
        });
        Api.Documents.save(document, extras).then((data) => {
          if (this.props.updateShipments && data.tms_shipments) {
            this.props.updateShipments(data.tms_shipments);
          }
          if (this.props.forceUpdateAndRefreshPopout) {
            this.props.forceUpdateAndRefreshPopout();
          }
        });
      };
      return renderPodUncheckReasonModal({
        onClose,
        onSubmit,
        doc: this.state.podUncheckReasonDocument,
        loadState: this.state.podUncheckReasonLoad,
        documentLoadRelationships: this.props.documentLoadRelationships
      });
    });
    __publicField(this, "possiblePodCheckReasonModal", () => {
      if (!this.state.showPodCheckReasonModal) return null;
      const onClose = () => {
        const doc = this.state.podCheckReasonDocument;
        setPOD(doc, false);
        this.setState({
          showPodCheckReasonModal: false,
          podCheckReasonDocument: null,
          podCheckReasonLoad: null
        });
        if (this.props.forceUpdateAndRefreshPopout) {
          this.props.forceUpdateAndRefreshPopout();
        }
      };
      const onSubmit = (reasonCodes, otherReasonText) => {
        const doc = this.state.podCheckReasonDocument;
        const load = this.state.podCheckReasonLoad;
        setPOD(doc, true);
        loadDocumentRelationshipService.forcePodDispositionForDocument(
          doc.id,
          true
        );
        const isConfirmSubmit = this.props.isConfirmAndSubmit;
        const extras = {
          load_state_id: load.id,
          page: isConfirmSubmit ? "confirm_and_submit" : "assign_to_load",
          pod_toggled: true,
          pod_reason_codes: reasonCodes,
          pod_reason: otherReasonText
        };
        this.setState({
          showPodCheckReasonModal: false,
          podCheckReasonDocument: null,
          podCheckReasonLoad: null
        });
        Api.Documents.save(doc, extras).then((data) => {
          if (this.props.updateShipments && data.tms_shipments) {
            this.props.updateShipments(data.tms_shipments);
          }
          if (this.props.forceUpdateAndRefreshPopout) {
            this.props.forceUpdateAndRefreshPopout();
          }
        });
      };
      return renderPodCheckReasonModal({
        onClose,
        onSubmit,
        doc: this.state.podCheckReasonDocument,
        loadState: this.state.podCheckReasonLoad,
        documentLoadRelationships: this.props.documentLoadRelationships
      });
    });
    __publicField(this, "editTextAnnotation", (e) => {
      const annotation = this.props.editedTextAnnotation;
      if (annotation) {
        this.props.dispatch(
          editTextAnnotationText(annotation.guid, e.target.value)
        );
      }
    });
    __publicField(this, "doneEditingText", (e) => {
      e.preventDefault();
      this.props.dispatch(doneEditingTextAnnotation());
    });
    __publicField(this, "possibleTextAnnotationEditArea", () => {
      if (this.props.editedTextAnnotation) {
        return /* @__PURE__ */ jsx("form", { onSubmit: this.doneEditingText, children: /* @__PURE__ */ jsxs("div", { className: "document-browser__text-annotation-edit-area", children: [
          /* @__PURE__ */ jsx(
            "textarea",
            {
              onChange: this.editTextAnnotation,
              value: this.props.editedTextAnnotation.data.text,
              placeholder: "Edit text\u2026"
            }
          ),
          /* @__PURE__ */ jsxs("div", { children: [
            /* @__PURE__ */ jsx("button", { type: "submit", className: "button--progress", children: "Done" }),
            /* @__PURE__ */ jsx(
              "a",
              {
                href: "#",
                style: { float: "right" },
                className: "button--caution alert",
                onClick: (e) => {
                  e.preventDefault();
                  this.props.dispatch(
                    deleteAnnotation(this.props.editedTextAnnotation.guid)
                  );
                },
                children: "Delete annotation"
              }
            )
          ] })
        ] }) });
      }
    });
    __publicField(this, "possibleZoomableImage", () => {
      const enabled = this.dragAndDropEnabled();
      if (!_.isEmpty(this.props.page)) {
        const urlsChanged = this.props.page != null && this.previouslySeenPage != null && (this.props.page.url !== this.previouslySeenPage.url || this.props.page.fullUrl !== this.previouslySeenPage.fullUrl || this.props.page.rawUrl !== this.previouslySeenPage.rawUrl || this.props.page.rawFullUrl !== this.previouslySeenPage.rawFullUrl);
        this.previouslySeenPage = Object.assign({}, this.props.page);
        return /* @__PURE__ */ jsx(
          ZoomableImage,
          {
            page: urlsChanged ? Object.assign({}, this.props.page) : this.props.page,
            textToHighlight: this.props.textToHighlight,
            dragAndDropEnabled: enabled,
            annotating: this.props.annotating,
            cropping: this.props.cropping,
            justSaved: this.state.justSaved,
            browserExpanded: this.props.browserExpanded,
            zoomLevel: this.zoomer.zoomLevel,
            annotationStampUrl: annotationStampUrl(this.props.model),
            toneAdjustments: this.props.toneAdjustments
          }
        );
      }
    });
    __publicField(this, "dragAndDropEnabled", () => {
      const page = this.currentPage();
      return this.zoomer.zoomLevel === 1 && !_.isEmpty(page.lines) && page.rotation === 0;
    });
    __publicField(this, "onProcessAttachment", () => {
      const currentPage_ = this.currentPage();
      if (currentPage_ != null) {
        const currentPageKey = pageKeyForAttachmentIsProcessingByPage(currentPage_);
        this.setState({
          attachmentIsProcessingByPage: __spreadProps(__spreadValues({}, this.state.attachmentIsProcessingByPage), {
            [currentPageKey]: true
          })
        });
      }
    });
    __publicField(this, "annotateToolbar", () => {
      const document = this.props.model.selectedDocument;
      if (this.props.allowsEditing && this.props.annotating && document) {
        return /* @__PURE__ */ jsx(
          AnnotateToolbar,
          {
            dispatch: this.props.dispatch,
            savingAnnotations: this.props.savingAnnotations,
            attachmentIsProcessing: this.attachmentIsProcessing(),
            onProcessAttachment: this.onProcessAttachment,
            allowsEditing: this.props.allowsEditing,
            annotating: this.props.annotating,
            cropping: this.props.cropping,
            page: this.props.page,
            annotationStampUrl: annotationStampUrl(this.props.model)
          }
        );
      }
    });
    __publicField(this, "downloadURL", () => {
      return documentEditor.downloadURL(this.props.model.selectedDocument.id);
    });
    __publicField(this, "downloadAllURL", () => {
      if (this.props.isConfirmAndSubmit || this.props.canDownloadAll) {
        let tokens;
        if (Auth._currentUser.account.factor_account) {
          tokens = this.props.model.selectedGroup.documents.map((d) => d.token).join();
        } else {
          const allDocuments = this.modelForAnnotations().allDocuments();
          tokens = allDocuments.map((d) => d.token).join();
        }
        return documentEditor.downloadAllURL(tokens);
      }
    });
    __publicField(this, "assignDocumentsSelector", () => {
      const load = this.onLoadUrl() ? this.props.load : this.props.selectedLoad;
      return getDocumentAssignmentComponent(
        flowStep(this.props),
        load,
        this.props.model.selectedDocument,
        Api.Account.currentSettings(),
        this.props.toggleDeliveryDocument,
        this.props.toggleCustomerLoadDocument,
        this.props.toggleShipmentDocument,
        this.allDocumentIds(),
        this.props.shipmentDocumentSelections,
        this.props.deliveryDocumentSelections,
        this.props.shipments,
        this.onLoadUrl()
      );
    });
    __publicField(this, "onLoadUrl", () => {
      var _a, _b;
      return !!this.props.load && ((_b = (_a = this.props.location) == null ? void 0 : _a.pathname) == null ? void 0 : _b.match(/\/loads\//));
    });
    __publicField(this, "allDocumentIds", () => {
      if (this.props.model.groups) {
        const documentIds = this.props.model.groups.map(
          (group) => group.documents.map((document) => document.id)
        );
        return _.flatten(documentIds);
      }
    });
    __publicField(this, "canMerge", () => {
      if (this.invoiceApproved()) {
        return false;
      }
      if (!this.propsAllowsSplitMerge()) {
        return false;
      }
      if (!this.props.model.previousDocument()) {
        return false;
      }
      if (Auth._currentUser.account.settings.documents_viewer_doctype_grouping_enabled) {
        return this.props.model.previousDocument().document_batch_id === this.props.model.selectedDocument.document_batch_id;
      }
      return true;
    });
    __publicField(this, "invoiceApproved", () => {
      const invoice = this.props.currentInvoice;
      return invoice && invoice.state && invoice.state === "approved";
    });
    __publicField(this, "propsAllowsSplitMerge", () => {
      if (this.props.allowsSplitMerge === false) {
        return false;
      } else {
        return true;
      }
    });
    __publicField(this, "canSplit", () => {
      const model = this.props.model;
      return this.propsAllowsSplitMerge() && model.selectedDocument && model.selectedDocument.pages && model.selectedDocument.pages.map((p) => p.id).indexOf(model.selectedPage.id) > 0;
    });
    this.zoomer = new Zoomer();
    const attachmentIsProcessingByPage = attachmentIsProcessingByPageFor(
      this.allDocumentPages()
    );
    this.state = {
      zoomLevel: this.zoomer.zoomLevel,
      annotating: false,
      justSaved: false,
      showToneSliders: false,
      attachmentIsProcessingByPage,
      // POD reason modal state
      showPodUncheckReasonModal: false,
      podUncheckReasonDocument: null,
      podUncheckReasonLoad: null,
      showPodCheckReasonModal: false,
      podCheckReasonDocument: null,
      podCheckReasonLoad: null
    };
  }
  componentDidMount() {
    this.mounted = true;
    $(DataStoreService).on(
      "DataStoreService:documentPageReplaced",
      this.handlePageReplaced
    );
    this.fetchLines(this.currentPage());
    hotkeys.listenInComponent(this, AccountsPayable, {
      zoomIn: this.zoomIn,
      zoomOut: this.zoomOut,
      rotateLeft: this.rotateLeft,
      rotateRight: this.rotateRight,
      markIllegible: () => this.props.toggleMarkIllegibleData(
        this.props.model.selectedDocument,
        this.props.page
      ),
      toggleHidden: () => {
        var _a, _b;
        return (_b = (_a = this.props).toggleHiddenData) == null ? void 0 : _b.call(
          _a,
          this.props.model.selectedDocument,
          this.props.page
        );
      }
    });
  }
  componentWillUnmount() {
    this.mounted = false;
    hotkeys.unlistenInComponent(this);
    $(DataStoreService).off(
      "DataStoreService:documentPageReplaced",
      this.handlePageReplaced
    );
  }
  componentWillReceiveProps(newProps) {
    this.setState({ justSaved: newProps.justSaved });
    if ((this.props.page && this.props.page.id) !== (newProps.page && newProps.page.id)) {
      this.fetchLines(newProps.page);
      this.resetToolState();
    }
  }
  render() {
    if (!this.props.page) {
      return this.noDocumentsView();
    }
    return /* @__PURE__ */ jsxs(
      "div",
      {
        "data-component": "DocumentBrowserMainImage",
        className: "document-browser__main-image-container",
        children: [
          /* @__PURE__ */ jsxs("div", { className: "document-browser__page-toolbar", children: [
            /* @__PURE__ */ jsx(
              PageToolbar,
              {
                zoomIn: this.zoomIn,
                attachmentIsProcessing: this.attachmentIsProcessing(),
                canZoomIn: this.zoomer.canZoomIn(),
                zoomOut: this.zoomOut,
                canZoomOut: this.zoomer.canZoomOut(),
                rotateLeft: this.rotateLeft,
                rotateRight: this.rotateRight,
                split: this.split,
                canSplit: this.canSplit(),
                merge: this.merge,
                canMerge: this.canMerge(),
                duplicate: this.duplicate,
                allowsEditing: this.props.allowsEditing,
                downloadAllURL: this.downloadAllURL(),
                downloadURL: this.downloadURL(),
                annotate: this.toggleAnnotation,
                annotating: this.props.annotating,
                canToggleHidden: canToggleHidden(this.props),
                toggleHidden: this.toggleHidden,
                markIllegible: this.markIllegible,
                canMarkIllegible: showMarkIllegibleButton(this.props),
                markedIllegible: this.props.page.illegible,
                viewEmail: viewEmail(this.props)
              }
            ),
            documentBrowserSubNav(__spreadProps(__spreadValues({}, this.props), {
              handlePodToggle: this.handlePodToggle
            })),
            this.annotateToolbar(),
            this.toneSliders(),
            this.assignDocumentsSelector(),
            /* @__PURE__ */ jsx(WaitingSpinner, { when: this.state.updating, children: /* @__PURE__ */ jsxs("div", { className: bem("__wrapper"), children: [
              this.possibleTextAnnotationEditArea(),
              this.possibleZoomableImage()
            ] }) })
          ] }),
          this.possiblePodUncheckReasonModal(),
          this.possiblePodCheckReasonModal()
        ]
      }
    );
  }
}
const connectedMainImage = connect(
  (state) => ({
    justSaved: state.annotationMode.justSaved,
    savingAnnotations: state.annotationMode.saving,
    annotating: state.annotationMode.annotating,
    cropping: state.annotationMode.cropping,
    editedTextAnnotation: state.textEditingMode,
    showToneSliders: state.annotationMode.showToneSliders,
    toneAdjustments: state.toneAdjustments
  }),
  null,
  null,
  { pure: false }
)(DocumentBrowserMainImage);
export default connectedMainImage;
